/**
 * @fileoverview GET handler for the "/apps/app_groups_using_catalogs" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupsUsingCatalogs } from "./constants";
import type { AppsAppGroupsUsingCatalogsResult } from "./types";

export const getAppsAppGroupsUsingCatalogs = reactQueryFetcherAdapter(
  appsAppGroupsUsingCatalogs,
  (signal: AbortSignal): Promise<AppsAppGroupsUsingCatalogsResult> => {
    return fetch("/apps/app_groups_using_catalogs", "GET", {}, { signal });
  }
);
